import { AppBar, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/system';
import { TOOLBAR_HEIGHT } from 'theme';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: 900,
  '& .MuiToolbar-gutters': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const StyledToolbar = styled(Toolbar)({
  minHeight: `${TOOLBAR_HEIGHT}px !important`,
});

const MenuContainer = styled(Grid)(({ theme }) => ({
  paddingRight: theme.spacing(1),
  marginLeft: `-${theme.spacing(2)}`,

  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

const MainContainer = styled(Grid)(() => ({
  display: 'block',
  alignItems: 'center',
  width: '15%',
}));

const FilterContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    order: 2,
  },
}));

const BreadcrumbContainer = styled(Grid)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    alignItems: 'flex-start',
  },
}));

const NavigationContainer = styled(Grid)(({ theme }) => ({
  width: '100%',
  position: 'relative',
  display: 'none',

  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}));

const ProgressBarContainer = styled('div')({
  height: '4px',
  backgroundColor: 'transparent',
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: '-4px',
});

export {
  StyledAppBar,
  StyledToolbar,
  MenuContainer,
  MainContainer,
  FilterContainer,
  BreadcrumbContainer,
  NavigationContainer,
  ProgressBarContainer,
};
